var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGroup3Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 435,
    viewBox: "0 0 448 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 53.4121,
    y: 91.0051,
    width: 117.332,
    height: 412.949,
    rx: 58.6661,
    transform: "rotate(-50.7093 53.4121 91.0051)",
    fill: "url(#paint0_linear_1043_89163)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 8.45369,
    y: 254.595,
    width: 105.33,
    height: 266.85,
    rx: 52.665,
    transform: "rotate(-49.9455 8.45369 254.595)",
    stroke: "url(#paint1_linear_1043_89163)",
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_89163",
    x1: 112.078,
    y1: 91.0051,
    x2: 112.078,
    y2: 503.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_89163",
    x1: 58.665,
    y1: 255.327,
    x2: 58.665,
    y2: 534.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGroup3Ic);
export default __webpack_public_path__ + "static/media/bgGroup3_ic.5a6344da.svg";
export { ForwardRef as ReactComponent };